// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__21kjZ","header":"MergedInvoice_header__3crWw"};